import type { Config } from "$global-providers/config-provider/provider";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  wrapper: {
    width: "100%",
    height: "100%",
  },
  header: {
    paddingBottom: 0,
  },
  content: {
    paddingTop: 0,
    display: "flex",
    flexDirection: "column",
    maxHeight: 310,
    overflowY: "scroll",
  },
  checkbox: {
    padding: 2,
  },
  formLabel: {
    marginLeft: 0,
  },
});

export interface Props {
  config: Config;
}

export const ConfigPanel: FC<Props> = ({ config }) => {
  const classes = useStyles();

  return (
    <Card className={classes.wrapper} elevation={2}>
      <CardHeader title="Config" className={classes.header} />
      <CardContent className={classes.content}>
        <pre>{JSON.stringify(config, null, 2)}</pre>
      </CardContent>
    </Card>
  );
};
